import httpClient from '@/api/http-client';

const endpoint = 'api/living-addresses';

const livingAddressService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  create: (livingAddress) => httpClient.post(`${endpoint}`, livingAddress),

  update: (livingAddress) => httpClient.put(`${endpoint}/${livingAddress.id}`, livingAddress),

  delete: (livingAddress) => httpClient.delete(`${endpoint}/${livingAddress.id}`),
};

export default livingAddressService;
